module.exports = __webpack_public_path__ + "static/ryantdlogov2.89aaf3ab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ryantdlogov2.svg
// module id = 373
// module chunks = 114276838955818